import { ecSite } from "./projects/ec-site/index";
import { todo } from "./projects/todo/index";
import { taskManagement } from "./projects/task-management/index";
import { aiChat } from "./projects/ai-chat/index";
import { analyticsDashboard } from "./projects/analytics-dashboard/index";
import { coffeeDaas } from "./projects/coffee-daas/index";
import { domainIntegrationDx } from "./projects/domain-integration-dx/index";
import { serverDomainMigration } from "./projects/server-domain-migration/index";
import { securityQualityDx } from "./projects/security-quality-dx/index";

export interface FigmaFrame {
  title: string;
  /** Figma の node-id（例: "1-102"） */
  nodeId: string;
}

export interface Chapter {
  num: number;
  title: string;
  /** この章の該当画面のFigmaフレーム */
  figmaFrames?: FigmaFrame[];
}

export type Difficulty = "beginner" | "intermediate" | "advanced";

export interface PracticalProject {
  id: string;
  num: number;
  title: string;
  description: string;
  duration: string;
  techStack: string[];
  figmaUrl?: string;
  /** 完成版を実際に触れるデモのURL */
  demoUrl?: string;
  /** お手本コードの言語ごとに動かせる見本の URL。キーは code/<言語>.json の言語名 */
  demoUrls?: Record<string, string>;
  /** demoUrls の見本をコードのページの中に埋め込んで動かす。埋め込むと動かない見本は付けず、新しいタブで開く */
  demoEmbed?: boolean;
  /** starter ブランチを実際に動かしたデモURL（受講生の出発点と同じ状態） */
  starterUrl?: string;
  /** GitHub リポジトリ URL（完成版 main） */
  repoUrl?: string;
  /** GitHub starter ブランチ URL（受講生が clone する出発点） */
  starterRepoUrl?: string;
  difficulty: Difficulty;
  phase: string;
  /** このプロジェクトを終えると身につくスキル */
  learningOutcomes: string[];
  chapters: Chapter[];
}

export const practicalProjects: PracticalProject[] = [
  todo,
  ecSite,
  taskManagement,
  aiChat,
  analyticsDashboard,
  coffeeDaas,
  domainIntegrationDx,
  serverDomainMigration,
  securityQualityDx,
];
